import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './block-custom.scss';

class BlockCustom extends PureComponent {
  render() {
    const style = {};

    if (!!this.props.image) {
      style.backgroundImage = `url(${this.props.image})`;
    }

    return (
      <div
        className={cn('block-custom', this.props.type)}
        style={style}
      >
        <div
          className="value"
          dangerouslySetInnerHTML={{ __html: this.props.value }}
        />

        {(this.props.title) &&
          <div
            className="title"
            dangerouslySetInnerHTML={{__html: this.props.title}}
          />
        }

        <div
          className="text"
          dangerouslySetInnerHTML={{ __html: this.props.text }}
        />
      </div>
    );
  }
}

BlockCustom.props = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string,
  value: PropTypes.string.isRequired,
  title: PropTypes.string,
  text: PropTypes.string.isRequired
};

export default BlockCustom;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/BlockCustom.js